// Angular + External
import { Component, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
// BFX

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Component({
  selector: "bfx-not-found",
  templateUrl: "./html/not-found.component.html",
  encapsulation: ViewEncapsulation.Emulated,
  standalone: false,
})
export class PageNotFoundComponent {
  public get frameTag() {
    return document.body.dataset.frameTag;
  }

  constructor(private _router: Router) {}

  public reroute(route: string): void {
    this._router.navigate([route]);
  }
}
